import React from "react";
import { Icon } from "antd";
import styles from "./index.module.scss";

interface HeaderProps {
    onCancel?: (evt: any) => void;
    title?: string; //标题名称
}

export default function Header({ onCancel, title = "预览附件" }: HeaderProps) {
    return (
        <div className={styles.root}>
            <h1 className={styles.title}>{title}</h1>

            <div className={styles.buttons}>
                <button className={styles.close} onClick={onCancel}>
                    <Icon type="close" />
                </button>
            </div>
        </div>
    );
}
